import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import html2canvas from 'html2canvas';
import autoTable from 'jspdf-autotable';
import { teluguText } from '../fonts-pdf/telugu-language-code';
import { kannadaText } from '../fonts-pdf/kannada-language-code';
import { hindiText } from '../fonts-pdf/hindi-language-code';
import jsPDF from 'jspdf';
import { error } from 'jquery';
import exportFromJSON from 'export-from-json';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { LoginService } from '../../../components/login/service/login.service';
import { NotifierService } from 'angular-notifier';
import { TextRecordService } from './service/text-record.service';

import { ChartOptions } from 'chart.js';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { PdfService } from './pdf-service/pdf.service';
import * as CryptoJS from 'crypto-js';
import { tamilText } from '../fonts-pdf/tamil-language-code';
import { EmailrecordService } from '../email/service/emailrecord.service';
@Component({
  selector: 'app-text-records',
  templateUrl: './text-records.component.html',
  styleUrl: './text-records.component.scss'
})
export class TextRecordsComponent {

  data = [];
  showData = 'text';
  showModal = 'dialogue';
  records1: any = [];
  tableData: any = [];
  textTableData: any = [];
  textTableRecords: any = [];
  myBlob = new Blob();
  keywordPercent!: number;
  metric_percentage!: number;
  pause_scorePercentage!: number;
  storeId: any;
  fileIndex!: number;
  transcriptModalData: any = [];
  transcriptModalDataTemp_T: any = [];
  transcriptModalDataTemp: any = [];
  dialogueList: any = [];
  keywordList: any = [];
  alertkeywordList: any = [];
  questionsData: any = [];
  englishQuestions: any = [];
  keywordSummary: any = [];
  mostUsedWords: any = [];
  textEntitiesData: any = [];
  transcriptModalData_T: any = [];
  dialogueList_T: any = [];
  keywordList_T: any = [];
  alertkeywordList_T: any = [];
  questionsData_T: any = [];
  englishQuestions_T: any = [];
  keywordSummary_T: any = [];
  mostUsedWords_T: any = [];
  textEntitiesData_T: any = [];
  input_1: any;
  input_2: any;
  spinner: boolean = false;
  bodySpinner: boolean = false;
  eyeShow: boolean = false;
  storeSpeakerName: any = [];
  tempVariable: any;
  display = 'none';
  filteredSpeaker: any = [];
  transcribedLg = ['English'];
  transcribedLgVariable!: string;
  showSelect: boolean = false;
  transcribedLg_T = ['English'];
  transcribedLgVariable_T!: string;
  showSelect_T: boolean = false;
  store_DSName: any = [];
  filtered_DSName: any = [];
  showRow: boolean = false;
  dialogueIndex!: number;
  inputType = 'button';
  inputValue!: string;
  transcriptIndex!: number;
  editedTranscript: any = [];
  searchText: any;
  searchText2: any;
  searchForm!: FormGroup;
  getSearchText: any;
  call_category: any = [];
  QAMetricsData: any = [];
  metricsMatches: any = [];
  modulationData: any = [];
  callCategoryIndex!: number;
  showPagination = false;
  page = 1;
  textPayload: any = {};
  metricsMScore!: number;
  metricsMComments = '';
  showManualInput = false;
  getMetricsIndex!: number;
  getRecordIndex!: number;
  infoDetails: any = [];
  infoTopicsName!: string;
  infoTopicsId!: string;
  infoForm!: FormGroup;
  getInfoTopics: any = [];
  splitPattern = new RegExp('[,;]');
  disableInput = false;
  infoEditShow = false;
  getInfoFormValue: any = [];
  getInfoTopicId!: string;
  userDetails: any;
  setTopicId!: string;
  getTableIndex!: number;
  sortingShow: boolean = false;
  selectedRow!: number;
  audioFileIndex = -1;
  filereader: any = new FileReader();
  audioSafeUrl!: SafeUrl;
  blobFile!: File;
  showsentiment = '';
  showSentimentWords = '';
  sentimentGraphData: any;
  sentimentData: any = [];
  sentimentPostiveWords: any = [];
  sentimentNegativeWords: any = [];
  sentimentNeutralWords: any = [];
  customerPostiveWords: any = [];
  customerNegativeWords: any = [];
  customerNeutralWords: any = [];
  agentPostiveWords: any = [];
  agentNegativeWords: any = [];
  agentNeutralWords: any = [];
  tableTrVar!: number;
  audioSpinner = false;
  blobUrl: any;
  audio: any;
  storeJsonBlob: any;
  displaySentiment: boolean = false;
  showPlayPause: boolean = false;
  showModalAudioTag: boolean = false;
  @ViewChild('searchSelect') searchSelect!: ElementRef;
  @ViewChild(DaterangepickerDirective, { static: false })
  pickerDirective!: DaterangepickerDirective;
  dateTime!: Date;
  getDateData: any;
  startDate: any;
  endDate: any;
  getInputSearchValue!: string;
  selectedSearchOption = 'default';
  inputSub!: Subscription;
  bound = 'inbound';
  keywordPhrases: any = [];
  keywordPhrases_T: any = [];
  downloadReportName = 'report';
  getMetricPercentage!: number;
  textEntitiesResult: any = [];
  textEntitiesResult_T: any = [];
  addEntity = false;
  getDownload!: string;
  getDownloadIndex!: number;
  downloadBtnSpinner:boolean = false;
  limit = 25;
  transcriptMinimizedBoolean: boolean = false;
  transcriptMinimizedHeader!: string;
  modalScreenSize!: string;
  infoDetailsLanguage!: string;
  usersRole!: number;
  ttfName!: string;
  fontName!: string;
  fontStyle: any;
  fontLanguage: any;
  translateResponseDataTemp: any = [];
  translateResponseData: any = [];
  translateResponseData_original: any = [];
  translateResponseData_originalTemp: any = [];
  modalArray = [
    'dialogue',
    'keyword',
    'alertKeywords',
    'questions',
    'summary',
    'mostUsedWords',
    'transcript',
    'textEntities',
  ];
  sentimentArray = ['overall', 'customer', 'agent'];
  sentimentWordsArray = ['positive', 'neutral', 'negative'];
  myOptions:any = {
    placement: 'top',
    showDelay: 200,
    hideDelay: 0,
    maxWidth: 200,
    zIndex: 100000,
    trigger: 'hover',
    shadow: true,
  };
  private readonly notifier: NotifierService;
  tranlateLanguages = [
    { lang: 'English', value: 'en' },
    { lang: 'Spanish', value: 'es' },
    { lang: 'Japanese', value: 'ja' },
    { lang: 'Vietnamese', value: 'vi' },
    { lang: 'Arabic', value: 'ar' },
    { lang: 'Bengali', value: 'bn' },
    { lang: 'Chinese', value: 'zh' },
    { lang: 'Dutch', value: 'nl' },
    { lang: 'Finnish', value: 'fi' },
    { lang: 'French', value: 'fr' },
    { lang: 'German', value: 'de' },
    { lang: 'Greek', value: 'el' },
    { lang: 'Hindi', value: 'hi' },
    { lang: 'Tamil', value: 'ta' },
    { lang: 'Urdu', value: 'ur' },
    { lang: 'Kannada', value: 'kn' },
    { lang: 'Telugu', value: 'te' },
    { lang: 'Marathi', value: 'mr' },
  ];
  selectedTranslate: any;
  selectedTranslate_1: any;
  getTranslateLanguage = 'en';
  fromLanguage!: string;
  toLanguage!: string;
  translateSpinner: boolean = false;
  displayName!: string;

  lineChartData: any = {
    labels: [],
    datasets: [
      {
        label: 'Sentiment Score',
        data: [],
        fill: false,
        datalabel: true,
        tension: 0.5,
        borderColor: '#36A2EB',
        backgroundColor: '#9BD0F5',
        pointBackgroundColor: (context: any) => {
          var index = context.dataIndex;
          var value = context.dataset.data[index];
          return value < 0 ? 'red' : '#565c78';
        },
      },
    ],
  };
  public lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    scales: {
      y: {
        suggestedMin: -1.0,
        suggestedMax: 1.0,
      },
    },
  };
  public lineChartLegend = true;
  //
  public tableSearch!: string;
  tableSearchUpdate = new Subject<string>();
  emailDataResponse: any = [];
  emailData: any = [];
  rowRecords:any[]=[];
  summaryData:any;
  QA_Pairs:any[]=[];
  metricFullscreen:boolean=false;
  constructor(
    private pdfService: PdfService,
    private textService: TextRecordService,
    private emailService: EmailrecordService,
    private notifierService: NotifierService,
    private fb: FormBuilder,
    private service: LoginService,
    private sanitizer: DomSanitizer
  ) {
    this.notifier = notifierService;
    this.tableSearchUpdate.pipe(debounceTime(400)).subscribe((value:any) => {
      this.searchTableData(value);
    });
  }

  ngOnInit(): void {
    this.dateTime = new Date();
    let user = localStorage.getItem("user");
       if(user){
        var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
        this.userDetails = JSON.parse(data);
       }   
   // this.userDetails = this.appComponent.userDetailsAppComp;
    this.usersRole = this.userDetails?.role;
    this.textPayload = {
      page: this.page,
        limit: this.limit,
        'filters': []
    };
   // this.loadPdfRecords();

    this.infoForm = this.fb.group({
      display_file_name: [null, Validators.required],
      agent_name: [null, Validators.required],
      topic: [null],
      own_key_words: [null],
      alert_keywords: [null],
      sensitive_words: [null],
      hide_keywords: [null],
      delete_words: [null],
      conversation: [null],
      language: [null],
    });
    this.transcribedLgVariable = this.transcribedLg[0];
    this.transcribedLgVariable_T = this.transcribedLg_T[0];
    this.loadTextRecord();
  }

 /* loadPdfRecords() {
    this.bodySpinner = true;
    this.pdfService.getPdfData(this.textPayload).subscribe({
      next: (response:any) => {
        this.records1 = response;
        this.tableData = this.records1.records;
        this.bodySpinner = false;
      },
      error: (err: any) => {
        console.log('fetch audio records error', err);
        this.bodySpinner = false;
      },
      complete: () => {
        this.bodySpinner = false;
      },
    });
  } */

  // text-record-section
  loadTextRecord() {
    this.bodySpinner = true;
    this.textService.getTextRecords(this.textPayload).subscribe({
      next: (response:any) => {
        this.textTableRecords = response;
        this.textTableData = this.textTableRecords.emails;
        this.bodySpinner = false;
      },
      error: (err: any) => {
        console.log('fetch audio records error', err);
        this.bodySpinner = false;
      },
      complete: () => {
        this.bodySpinner = false;
      },
    });
  }

  // email records section
  getEmailDataFun() {
    this.bodySpinner = true;
   /* this.emailService.getEmailData().subscribe({
      next: (response:any) => {
        this.emailDataResponse = response;
        this.emailData = this.emailDataResponse.result;
        this.emailData.reverse();
        this.bodySpinner = false;
      },
      error: (err:any) => {
        console.log('email error', err);
        this.bodySpinner = false;
      },
    }); */
  }
  openDoc(data: string) {
    this.showData = data;
    this.tableSearch = '';
    if (this.showData === 'pdf') {
      this.textPayload = {
        pageno: this.page,
        limit: this.limit,
        sort: [{ property: 'created_date', dir: 'DESC' }],
        search: '',
      };
     // this.loadPdfRecords();
    }
    if (this.showData === 'text') {
      this.textPayload = {
        pageno: this.page,
        limit: this.limit,
        sort: [{ property: 'created_date', dir: 'DESC' }],
        search: '',
      };
      this.loadTextRecord();
    }
    if (this.showData === 'emailTable') {
      this.getEmailDataFun();
    }
  }

  pageChanged(event: any) {
    this.page = event;
    this.textPayload.pageno = event;
    this.textPayload.page = event;
    this.loadTextRecord();
    // if (this.showData === 'pdf') {
    //   this.loadPdfRecords();
    // }
    // if (this.showData === 'text') {
    //   this.loadTextRecord();
    // }
    // if (this.showData === 'text') {
      
    // }
  }

  tableBack(index: number) {
    this.tableTrVar = index;
  }

  CallCategoryIndex(index: number) {
    if (this.showData === 'pdf') {
      this.callCategoryIndex = index;
      this.call_category = this.tableData[index].call_category;
      this.modulationData = this.tableData[index].modulation_matches;
      this.tableData[index].read = 'Y';
    }
    if (this.showData === 'text') {
      this.callCategoryIndex = index;
      this.call_category = this.textTableData[index].call_category;
      this.modulationData = this.textTableData[index].modulation_matches;
      this.textTableData[index].read = 'Y';
    }
  }

  sortFun() {
    if (this.showData === 'pdf') {
      if (this.audioFileIndex === -1) {
        if (!this.sortingShow) {
          // ascending order old to new
          const sortedAsc = this.tableData.sort(
            (objA: any, objB: any) =>
              new Date(objA.updated_date).getTime() -
              new Date(objB.updated_date).getTime()
          );
          this.sortingShow = !this.sortingShow;
        } else if (this.sortingShow) {
          // descending order new to old
          const sortedDesc = this.tableData.sort(
            (objA: any, objB: any) =>
              new Date(objB.updated_date).getTime() -
              new Date(objA.updated_date).getTime()
          );
          this.sortingShow = !this.sortingShow;
        }
      }
    }

    if (this.showData === 'text') {
      if (this.audioFileIndex === -1) {
        if (!this.sortingShow) {
          // ascending order old to new
          const sortedAsc = this.textTableData.sort(
            (objA: any, objB: any) =>
              new Date(objA.updated_date).getTime() -
              new Date(objB.updated_date).getTime()
          );
          this.sortingShow = !this.sortingShow;
        } else if (this.sortingShow) {
          // descending order new to old
          const sortedDesc = this.textTableData.sort(
            (objA: any, objB: any) =>
              new Date(objB.updated_date).getTime() -
              new Date(objA.updated_date).getTime()
          );
          this.sortingShow = !this.sortingShow;
        }
      }
    }
    if (this.showData === 'emailTable') {
      if (this.audioFileIndex === -1) {
        if (!this.sortingShow) {
          // ascending order old to new
          const sortedAsc = this.emailData.sort(
            (objA: any, objB: any) =>
              new Date(objA.created_date).getTime() -
              new Date(objB.created_date).getTime()
          );
          this.sortingShow = !this.sortingShow;
        } else if (this.sortingShow) {
          // descending order new to old
          const sortedDesc = this.emailData.sort(
            (objA: any, objB: any) =>
              new Date(objB.created_date).getTime() -
              new Date(objA.created_date).getTime()
          );
          this.sortingShow = !this.sortingShow;
        }
      }
    }
  }

  getTextSummaryFun(index:number){
      this.summaryData = this.textTableData[index]['text_summary'];
  }
  getSentimentFun(index: number) {
     this.sentimentData = this.textTableData[index];
    if (this.showData === 'pdf') {
      const ind = index;
      this.tableData[index].read = 'Y';
      this.sentimentData = this.tableData[index];
      this.sentimentPostiveWords = this.tableData[index]?.positive_words[0];
      this.sentimentNeutralWords = this.tableData[index]?.neutral_words[0];
      this.sentimentNegativeWords = this.tableData[index]?.negative_words[0];
      this.customerPostiveWords =
        this.tableData[index]?.customer_positive_words;
      this.customerNeutralWords = this.tableData[index]?.customer_neutral_words;
      this.customerNegativeWords =
        this.tableData[index]?.customer_negative_words;
      this.agentPostiveWords = this.tableData[index]?.agent_positive_words;
      this.agentNeutralWords = this.tableData[index]?.agent_neutral_words;
      this.agentNegativeWords = this.tableData[index]?.agent_negative_words;
      this.sentimentGraphData = this.tableData[index]?.sentiment_graph[0];
    }
    if (this.showData === 'text') {
      const ind = index;
      this.textTableData[index].read = 'Y';
      this.sentimentData = this.textTableData[index];
      this.sentimentPostiveWords = this.textTableData[index]?.positive_words[0];
      this.sentimentNeutralWords = this.textTableData[index]?.neutral_words[0];
      this.sentimentNegativeWords =
        this.textTableData[index]?.negative_words[0];
      this.customerPostiveWords =
        this.textTableData[index]?.customer_positive_words;
      this.customerNeutralWords =
        this.textTableData[index]?.customer_neutral_words;
      this.customerNegativeWords =
        this.textTableData[index]?.customer_negative_words;
      this.agentPostiveWords = this.textTableData[index]?.agent_positive_words;
      this.agentNeutralWords = this.textTableData[index]?.agent_neutral_words;
      this.agentNegativeWords = this.textTableData[index]?.agent_negative_words;
      this.sentimentGraphData = this.textTableData[index]?.sentiment_graph[0];
    }
    if (this.showData === 'emailTable') {
      const ind = index;
      this.emailData[index].read = 'Y';
      this.sentimentData = this.emailData[index];
      this.sentimentPostiveWords = this.emailData[index]?.positive_words;
      this.sentimentNeutralWords = this.emailData[index]?.neutral_words;
      this.sentimentNegativeWords = this.emailData[index]?.negative_words;
      this.customerPostiveWords =
        this.emailData[index]?.customer_positive_words;
      this.customerNeutralWords = this.emailData[index]?.customer_neutral_words;
      this.customerNegativeWords =
        this.emailData[index]?.customer_negative_words;
      this.agentPostiveWords = this.emailData[index]?.agent_positive_words;
      this.agentNeutralWords = this.emailData[index]?.agent_neutral_words;
      this.agentNegativeWords = this.emailData[index]?.agent_negative_words;
      this.sentimentGraphData = this.emailData[index]?.sentiment_graph;
    }
  }

  getRowRecords(index:number){
       this.rowRecords=[];
       this.rowRecords = this.textTableData[index]['row'];
  }

  sentimentHeading(value: string) {
    this.sentimentArray.forEach((item) => {
      if (value === item) {
        this.showsentiment = value;
      }
    });
    if (this.showsentiment === 'overall') {
      this.lineChartData.datasets[0].data = this.sentimentGraphData;
      this.lineChartData.labels = this.sentimentGraphData;
    }
  }

  sentimentWordsHeading(value: string) {
    this.sentimentWordsArray.forEach((item) => {
      if (value === item) {
        this.showSentimentWords = value;
      }
    });
  }

  getTranscriptFun(index: number, name: string) {
    this.searchText = '';
    if (this.transcribedLg_T.length > 1) {
      this.transcribedLg_T.shift();
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (this.showData === 'pdf') {
      this.spinner = true;
      this.fileIndex = index;
      this.storeId = this.tableData[this.fileIndex]?.file_id.$oid;
      if (name == 'transcript') {
        this.pdfService.getTranscriptData(this.storeId).subscribe(
          (sub: any) => {
            this.transcriptModalData_T = sub;
            const language = this.transcriptModalData_T[0]?.language;
            if (language === 'en' || language.slice(0, 2) === 'en') {
              this.dialogueList_T =
                this.transcriptModalData_T[0]?.text.split(/[.?]/);
              this.mostUsedWords_T =
                this.transcriptModalData_T[0]?.most_used_words;
            } else {
              this.dialogueList_T =
                this.transcriptModalData_T[0]?.spanish_text.split(/[.?]/);
              this.mostUsedWords_T =
                this.transcriptModalData_T[0]?.spanish_most_used_words;
            }
            this.transcriptSelectedLgFunTranscriptModal(language);
            this.spinner = false;
            this.tableData[index].read = 'Y';
            if (this.textEntitiesData_T?.length < 1) {
              this.textEntitiesData_T =
                this.transcriptModalData_T[0]?.text_entities;
              for (let obj of this.textEntitiesData_T) {
                for (let key in obj) {
                  let textEntityObj = {
                    propertyKey: key.split('(dot)').join('.'),
                    propertyValue: obj[key].split('(dot)').join('.'),
                  };
                  this.textEntitiesResult_T.push(textEntityObj);
                }
              }
            }
            this.globalSearchHighlighterFun();
          },
          (error: any) => {
            console.log('Transcript got error', error);
            this.spinner = false;
          }
        );
      }

      if (name == 'questions') {
        this.pdfService.getKeywordTranscriptData(this.storeId).subscribe(
          (sub: any) => {
            this.questionsData_T = sub;
            this.keywordPhrases_T =
              this.questionsData_T[0]?.own_keywords_result;
            this.alertkeywordList_T =
              this.questionsData_T[0]?.alert_keywords_result;
            this.tableData[index].read = 'Y';
            this.keywordPhrases_T.sort((a: any, b: any) => {
              return b.count - a.count;
            });
            this.alertkeywordList_T.sort((a: any, b: any) => {
              return b.count - a.count;
            });
            const language = this.questionsData_T[0]?.language;
            if (language === 'en' || language.slice(0, 2) === 'en') {
              this.englishQuestions_T = this.questionsData_T[0]?.questions;
              this.keywordSummary_T = this.questionsData_T[0]?.keywords;
            } else {
              this.englishQuestions_T =
                this.questionsData_T[0]?.spanish_questions;
              this.keywordSummary_T = this.questionsData_T[0]?.spanish_keywords;
            }

            this.transcriptSelectedLgFunTranscriptModal(language);
            this.spinner = false;
            this.keywordPhrases_T.sort((a: any, b: any) => {
              return b.count - a.count;
            });
            this.alertkeywordList_T.sort((a: any, b: any) => {
              return b.count - a.count;
            });
            this.globalSearchHighlighterFun();
          },
          (error: any) => {
            console.log('transcript keywords error: ', error);
            this.spinner = false;
          }
        );
      }
    }
    if (this.showData === 'text') {
      this.spinner = true;
      this.fileIndex = index;
      this.storeId = this.textTableData[this.fileIndex]?.file_id.$oid;
      if (name == 'transcript') {
        this.textService.getTranscript(this.storeId).subscribe(
          (sub: any) => {
            this.transcriptModalData_T = sub;
            const language = this.transcriptModalData_T[0]?.language;
            if (language === 'en' || language.slice(0, 2) === 'en') {
              this.dialogueList_T =
                this.transcriptModalData_T[0]?.text.split(/[.?]/);
              this.mostUsedWords_T =
                this.transcriptModalData_T[0]?.most_used_words;
            } else {
              this.dialogueList_T =
                this.transcriptModalData_T[0]?.spanish_text.split(/[.?]/);
              this.mostUsedWords_T =
                this.transcriptModalData_T[0]?.spanish_most_used_words;
            }
            this.transcriptSelectedLgFunTranscriptModal(language);
            this.globalSearchHighlighterFun();
            this.spinner = false;
            this.textTableData[index].read = 'Y';
          },
          (error: any) => {
            console.log('Transcript got error', error);
            this.spinner = false;
          }
        );
      }

      if (name == 'questions') {
        this.textService.getTextKeywordPercentage(this.storeId).subscribe(
          (sub: any) => {
            this.questionsData_T = sub;
            this.keywordPhrases_T =
              this.questionsData_T[0]?.own_keywords_result;
            this.alertkeywordList_T =
              this.questionsData_T[0]?.alert_keywords_result;
            const language = this.questionsData_T[0]?.language;
            this.transcriptSelectedLgFunTranscriptModal(language);
            if (language === 'en' || language.slice(0, 2) === 'en') {
              this.keywordSummary_T = this.questionsData_T[0]?.keywords;
              this.englishQuestions_T = this.questionsData_T[0]?.questions;
            } else {
              this.keywordSummary_T = this.questionsData_T[0]?.spanish_keywords;
              this.englishQuestions_T =
                this.questionsData_T[0]?.spanish_questions;
            }
            this.textTableData[index].read = 'Y';
            this.keywordPhrases_T.sort((a: any, b: any) => {
              return b.count - a.count;
            });
            this.alertkeywordList_T.sort((a: any, b: any) => {
              return b.count - a.count;
            });
            this.globalSearchHighlighterFun();
            this.spinner = false;
          },
          (error: any) => {
            console.log('transcript keywords error: ', error);
            this.spinner = false;
          }
        );
      }
    }
    if (this.showData === 'emailTable') {
      this.fileIndex = index;
      this.storeId = this.emailData[this.fileIndex]?.file_id.$oid;
      if (name == 'transcriptModal') {
        this.spinner = true;
        this.emailService.getTranscriptData(this.storeId).subscribe(
          (sub: any) => {
            this.transcriptModalDataTemp_T = sub;
            this.questionsData_T = this.transcriptModalDataTemp_T.result;
            this.dialogueList_T = this.questionsData_T?.text?.split(/[.?]/);
            this.mostUsedWords_T = this.questionsData_T?.most_used_words;
            this.keywordPhrases_T = this.questionsData_T?.own_keywords_result;
            this.alertkeywordList_T =
              this.questionsData_T?.alert_keywords_result;
            this.keywordSummary_T = this.questionsData_T?.keywords;
            this.englishQuestions_T = this.questionsData_T?.questions;
            this.emailData[index].read = 'Y';
            this.keywordPhrases_T?.sort((a: any, b: any) => {
              return b.count - a.count;
            });
            this.alertkeywordList_T?.sort((a: any, b: any) => {
              return b.count - a.count;
            });
            this.globalSearchHighlighterFun();
            this.spinner = false;
          },
          (error: any) => {
            console.log('transcript keywords error: ', error);
            this.spinner = false;
          }
        );
      }
      if (name == 'otherModal') {
        this.spinner = true;
        this.emailService.getTranscriptData(this.storeId).subscribe(
          (sub: any) => {
            this.transcriptModalDataTemp = sub;
            this.questionsData = this.transcriptModalDataTemp.result;
            this.dialogueList = this.questionsData?.text?.split(/[.?]/);
            this.globalSearchHighlighterFun();
            this.spinner = false;
          },
          (error: any) => {
            console.log('transcript keywords error: ', error);
            this.spinner = false;
          }
        );
      }
      if (name == 'questions' || name == 'transcript') {
        this.globalSearchHighlighterFun();
      }
    }
  }

  transcriptSelectedLgFun(language: string) {
    if (language === 'es' || language?.slice(0, 2) === 'es') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Spanish');
      }
      this.transcribedLgVariable = this.transcribedLg[0];
      this.showSelect_T = true;
    }
    if (language === 'hi' || language?.slice(0, 2) === 'hi') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Hindi');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (language === 'en' || language?.slice(0, 2) === 'en') {
      this.showSelect = false;
    }
    if (language === 'kn' || language?.slice(0, 2) === 'kn') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Kannada');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (language === 'ta' || language.slice(0, 2) === 'ta') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Tamil');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (language === 'mr' || language.slice(0, 2) === 'mr') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Marathi');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (language === 'te' || language.slice(0, 2) === 'te') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Telugu');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (language === 'gu' || language.slice(0, 2) === 'gu') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Gujarati');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (language === 'bn' || language.slice(0, 2) === 'bn') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Bengali');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
  }

  transcriptSelectedLgFunTranscriptModal(language: string) {
    if (language === 'es' || language?.slice(0, 2) === 'es') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Spanish');
      }
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
      this.showSelect_T = true;
    }
    if (language === 'hi' || language?.slice(0, 2) === 'hi') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Hindi');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (language === 'en' || language?.slice(0, 2) === 'en') {
      this.showSelect_T = false;
    }
    if (language === 'kn' || language?.slice(0, 2) === 'kn') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Kannada');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (language === 'ta' || language.slice(0, 2) === 'ta') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Tamil');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (language === 'mr' || language.slice(0, 2) === 'mr') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Marathi');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (language === 'te' || language.slice(0, 2) === 'te') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Telugu');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (language === 'gu' || language.slice(0, 2) === 'gu') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Gujarati');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (language === 'bn' || language.slice(0, 2) === 'bn') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Bengali');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
  }

  changeTranscriptLgFun() {
    this.searchText = '';
    if (this.transcribedLgVariable_T === 'English') {
      this.dialogueList_T = this.transcriptModalData_T[0]?.text.split(/[.?]/);
      this.englishQuestions_T = this.questionsData_T[0]?.questions;
      this.keywordSummary_T = this.questionsData_T[0]?.keywords;
      this.mostUsedWords_T = this.transcriptModalData_T[0]?.most_used_words;
    } else {
      this.dialogueList_T =
        this.transcriptModalData_T[0]?.spanish_text.split(/[.?]/);
      this.englishQuestions_T = this.questionsData_T[0]?.spanish_questions;
      this.keywordSummary_T = this.questionsData_T[0]?.spanish_keywords;
      this.mostUsedWords_T =
        this.transcriptModalData_T[0]?.spanish_most_used_words;
    }
    this.globalSearchHighlighterFun();
  }

  DownloadEntityData() {
    if (this.showData === 'pdf') {
      exportFromJSON({
        data: this.textEntitiesResult_T,
        fileName: this.tableData[this.fileIndex].display_file_name,
        exportType: 'json',
      });
    }
    if (this.showData === 'text') {
      exportFromJSON({
        data: this.textEntitiesResult_T,
        fileName: this.textTableData[this.fileIndex].display_file_name,
        exportType: 'json',
      });
    }
  }

  downloadJson() {
    this.storeJsonBlob = new Blob(
      [JSON.stringify(this.transcriptModalData_T[0].text_entities)],
      { type: 'application/json' }
    );
    this.blobUrl = URL.createObjectURL(this.storeJsonBlob);
    this.audioSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.blobUrl
    );
  }

  clearKeywordDetailsTranscriptModal() {
    setTimeout(() => {
      this.modalScreenSize = '';
      this.transcriptModalData_T = [];
      this.transcriptModalDataTemp_T = [];
      this.dialogueList_T = [];
      this.keywordList_T = [];
      this.alertkeywordList_T = [];
      this.keywordSummary_T = [];
      this.mostUsedWords_T = [];
      this.questionsData_T = [];
      this.englishQuestions_T = [];
      this.keywordPhrases_T = [];
      if (this.transcribedLg_T.length > 1) {
        this.transcribedLg_T.shift();
      }
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
      this.showSelect_T = false;
    }, 400);
    this.searchText = '';
  }

  clearKeywordDetails() {
    setTimeout(() => {
      this.transcriptModalData = [];
      this.transcriptModalDataTemp = [];
      this.dialogueList = [];
      this.keywordList = [];
      this.infoDetails = [];
      this.alertkeywordList = [];
      this.keywordSummary = [];
      this.mostUsedWords = [];
      this.questionsData = [];
      this.englishQuestions = [];
      this.keywordPhrases = [];
      if (this.transcribedLg.length > 1) {
        this.transcribedLg.shift();
      }
      this.transcribedLgVariable = this.transcribedLg[0];
      this.showSelect = false;
    }, 400);
    this.searchText = '';
  }

  clearRecordData() {
    this.infoEditShow = false;
    this.infoDetails = [];
    this.infoTopicsName = '';
    this.infoForm.reset();
  }

  getQAMetricsData(index: number) {
    if (this.showData === 'pdf') {
      this.QAMetricsData = this.tableData[index].metrics_matches;
      this.metricsMatches = this.QAMetricsData;
      this.getMetricPercentage = this.tableData[index].metric_percentage;
    }
    if (this.showData === 'text') {
      this.QAMetricsData = this.textTableData[index].metrics_matches;
      this.metricsMatches = this.QAMetricsData;
      this.getMetricPercentage = this.textTableData[index].metric_percentage;
    }
  }

  modalHeading(value: string) {
    this.modalArray.forEach((item) => {
      if (value == item) {
        this.showModal = value;
      }
    });
  }

  getReportData(index: number, value: string) {
    this.getDownload = value;
    if (this.transcribedLg.length > 1) {
      this.transcribedLg.shift();
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (this.getDownload === 'download') {
      this.getDownloadIndex = index;
    }
    this.spinner = true;
    if (this.showData === 'pdf') {
      this.infoDetails = this.tableData[index];
      this.downloadReportName = this.tableData[index]?.display_file_name;
      this.fileIndex = index;
      this.storeId = this.tableData[this.fileIndex]?.file_id.$oid;
      if (value === 'keywordPercentage') {
        this.pdfService.getKeywordTranscriptData(this.storeId).subscribe(
          (sub: any) => {
            this.questionsData = sub;
            this.keywordPhrases = this.questionsData[0].own_keywords_result;
            this.keywordPhrases.sort((a: any, b: any) => {
              return b.count - a.count;
            });
            const language = this.questionsData[0].language;
            this.transcriptSelectedLgFun(language);
            this.spinner = false;
          },
          (error: any) => {
            console.log('transcript keywords error: ', error);
            this.spinner = false;
          }
        );
      } else {
        this.pdfService.getTranscriptData(this.storeId).subscribe(
          (sub: any) => {
            this.transcriptModalData = sub;
            this.textEntitiesData = this.transcriptModalData[0].text_entities;
            this.tableData[index].read = 'Y';
            const language = this.transcriptModalData[0]?.language;
            if (language === 'en' || language.slice(0, 2) === 'en') {
              this.dialogueList =
                this.transcriptModalData[0]?.text.split(/[.?]/);
              this.mostUsedWords = this.transcriptModalData[0]?.most_used_words;
            } else {
              this.dialogueList =
                this.transcriptModalData[0]?.spanish_text.split(/[.?]/);
              this.mostUsedWords =
                this.transcriptModalData[0]?.spanish_most_used_words;
            }
            this.transcriptSelectedLgFun(language);
            if (this.getDownload === 'report') {
              this.spinner = false;
            }
          },
          (error: any) => {
            console.log('Transcript got error', error);
            this.spinner = false;
          }
        );

        this.pdfService.getKeywordTranscriptData(this.storeId).subscribe(
          (sub: any) => {
            this.questionsData = sub;
            this.keywordPhrases = this.questionsData[0].own_keywords_result;
            this.alertkeywordList = this.questionsData[0].alert_keywords_result;
            this.keywordPhrases.sort((a: any, b: any) => {
              return b.count - a.count;
            });
            this.alertkeywordList.sort((a: any, b: any) => {
              return b.count - a.count;
            });
            const language = this.questionsData[0].language;
            this.transcriptSelectedLgFun(language);
            if (this.questionsData[0].language.slice(0, 2) === 'en') {
              this.englishQuestions = this.questionsData[0].questions;
              this.keywordSummary = this.questionsData[0].keywords;
            } else {
              this.englishQuestions = this.questionsData[0].spanish_questions;
              this.keywordSummary = this.questionsData[0].spanish_keywords;
            }
            if (this.getDownload === 'download') {
              this.makePDF();
            } else {
              this.spinner = false;
            }
          },
          (error: any) => {
            console.log('transcript keywords error: ', error);
            this.spinner = false;
          }
        );
      }
    }

    if (this.showData === 'text') {
      this.infoDetails = this.textTableData[index];
      this.downloadReportName = this.textTableData[index]?.display_file_name;
      this.fileIndex = index;
      this.storeId = this.textTableData[this.fileIndex]?.file_id.$oid;
      if (value === 'keywordPercentage') {
        this.textService.getTextKeywordPercentage(this.storeId).subscribe(
          (sub: any) => {
            this.questionsData = sub;
            this.keywordPhrases = this.questionsData[0].own_keywords_result;
            this.keywordPhrases.sort((a: any, b: any) => {
              return b.count - a.count;
            });
            this.spinner = false;
          },
          (error: any) => {
            this.spinner = false;
            console.log('transcript keywords error: ', error);
          }
        );
      } else {
        this.textService.getTranscript(this.storeId).subscribe(
          (sub: any) => {
            this.transcriptModalData = sub;
            this.textEntitiesData = this.transcriptModalData[0].text_entities;
            this.textTableData[index].read = 'Y';
            const language = this.transcriptModalData[0]?.language;
            this.transcriptSelectedLgFun(language);
            if (language === 'en') {
              this.dialogueList =
                this.transcriptModalData[0]?.text.split(/[.?]/);
              this.mostUsedWords = this.transcriptModalData[0]?.most_used_words;
            } else {
              this.dialogueList =
                this.transcriptModalData[0]?.spanish_text.split(/[.?]/);
              this.mostUsedWords =
                this.transcriptModalData[0]?.spanish_most_used_words;
            }
          },
          (error: any) => {
            this.spinner = false;
            console.log('Transcript got error', error);
          }
        );

        this.textService.getTextKeywordPercentage(this.storeId).subscribe(
          (sub: any) => {
            this.questionsData = sub;
            this.keywordPhrases = this.questionsData[0].own_keywords_result;
            this.alertkeywordList = this.questionsData[0].alert_keywords_result;
            const language = this.questionsData[0].language;
            this.transcriptSelectedLgFun(language);
            this.keywordPhrases.sort((a: any, b: any) => {
              return b.count - a.count;
            });
            this.alertkeywordList.sort((a: any, b: any) => {
              return b.count - a.count;
            });
            if (
              this.questionsData[0].language === 'en' ||
              this.questionsData[0].language === 'English'
            ) {
              this.englishQuestions = this.questionsData[0].questions;
              this.keywordSummary = this.questionsData[0].keywords;
            } else {
              this.englishQuestions = this.questionsData[0].spanish_questions;
              this.keywordSummary = this.questionsData[0].spanish_keywords;
            }
            if (this.getDownload === 'download') {
              this.makePDF();
            } else {
              this.spinner = false;
            }
          },
          (error: any) => {
            this.spinner = false;
            console.log('transcript keywords error: ', error);
          }
        );
      }
    }

    // if (this.showData === 'emailTable') {
    //   this.infoDetails = this.emailData[index];
    //   this.downloadReportName = this.emailData[index]?.display_file_name;
    //   this.fileIndex = index;
    //   this.storeId = this.emailData[this.fileIndex]?.file_id.$oid;
    //   if (value === 'keywordPercentage') {
    //     this.emailService.getTranscriptData(this.storeId).subscribe(
    //       (sub: any) => {
    //         this.questionsData = sub;
    //         this.keywordPhrases = this.questionsData[0]?.own_keywords_result;
    //         this.keywordPhrases.sort((a: any, b: any) => {
    //           return b.count - a.count;
    //         });
    //         this.spinner = false;
    //       },
    //       (error: any) => {
    //         this.spinner = false;
    //         console.log('transcript keywords error: ', error);
    //       }
    //     );
    //   } else {
    //     this.emailService.getTranscriptData(this.storeId).subscribe(
    //       (sub: any) => {
    //         this.transcriptModalDataTemp = sub
    //         this.transcriptModalData = this.transcriptModalDataTemp.result;
    //         console.log("trans", this.transcriptModalData)
    //         this.keywordPhrases = this.transcriptModalData.own_keywords_result;
    //         this.alertkeywordList = this.transcriptModalData.alert_keywords_result;
    //         this.emailData[index].read = 'Y';
    //         const language = this.transcriptModalData[0]?.language;
    //         this.transcriptSelectedLgFun(language);
    //         if (language === 'en') {
    //           this.dialogueList =
    //             this.transcriptModalData[0]?.text.split(/[.?]/);
    //           this.mostUsedWords = this.transcriptModalData[0]?.most_used_words;
    //         } else {
    //           this.dialogueList =
    //             this.transcriptModalData[0]?.spanish_text.split(/[.?]/);
    //           this.mostUsedWords =
    //             this.transcriptModalData[0]?.spanish_most_used_words;
    //         }
    //       },
    //       (error: any) => {
    //         this.spinner = false;
    //         console.log('Transcript got error', error);
    //       }
    //     );

    //     this.emailService.getTranscriptData(this.storeId).subscribe(
    //       (sub: any) => {
    //         this.questionsData = sub;
    //         // this.keywordPhrases = this.questionsData[0]?.own_keywords_result;
    //         // this.alertkeywordList = this.questionsData[0]?.alert_keywords_result;
    //         const language = this.questionsData[0]?.language;
    //         this.transcriptSelectedLgFun(language);
    //         this.keywordPhrases.sort((a: any, b: any) => {
    //           return b.count - a.count;
    //         });
    //         this.alertkeywordList.sort((a: any, b: any) => {
    //           return b.count - a.count;
    //         });
    //         if (
    //           this.questionsData[0]?.language === 'en' ||
    //           this.questionsData[0]?.language === 'English'
    //         ) {
    //           this.englishQuestions = this.questionsData[0]?.questions;
    //           this.keywordSummary = this.questionsData[0]?.keywords;
    //         } else {
    //           this.englishQuestions = this.questionsData[0]?.spanish_questions;
    //           this.keywordSummary = this.questionsData[0]?.spanish_keywords;
    //         }
    //         if (this.getDownload === 'download') {
    //           this.makePDF();
    //         } else {
    //           this.spinner = false;
    //         }
    //       },
    //       (error: any) => {
    //         this.spinner = false;
    //         console.log('transcript keywords error: ', error);
    //       }
    //     );
    //   }
    // }
  }

  changeTranscriptLgReport() {
    if (this.transcribedLgVariable === 'English') {
      this.dialogueList = this.transcriptModalData[0]?.text.split(/[.?]/);
      this.englishQuestions = this.questionsData[0]?.questions;
      this.keywordSummary = this.questionsData[0]?.keywords;
      this.mostUsedWords = this.transcriptModalData[0]?.most_used_words;
    } else {
      this.dialogueList =
        this.transcriptModalData[0]?.spanish_text.split(/[.?]/);
      this.englishQuestions = this.questionsData[0]?.spanish_questions;
      this.keywordSummary = this.questionsData[0]?.spanish_keywords;
      this.mostUsedWords = this.transcriptModalData[0]?.spanish_most_used_words;
    }
  }

  getInfoData(index: number) {
    this.spinner = true;
    if (this.showData === 'pdf') {
      this.getTableIndex = index;
      this.infoDetails = this.tableData[index];
      if (
        this.infoDetails.language === 'en' ||
        this.infoDetails.language === 'en-US'
      ) {
        this.infoDetailsLanguage = 'English';
      }
      if (this.infoDetails.language === 'hi') {
        this.infoDetailsLanguage = 'Hindi';
      }
      if (this.infoDetails.language === 'es') {
        this.infoDetailsLanguage = 'Spanish';
      }
      if (this.infoDetails.language === 'kn') {
        this.infoDetailsLanguage = 'Kannada';
      }
      const checkId = this.tableData[index].topic.toString();
      this.pdfService.getInfo().subscribe({
        next:(res:any) => {
          const data: any = res;
          this.getInfoTopics = data.topics;
          this.storeId = this.tableData[index]?.topic;
          for (let i = 0; this.getInfoTopics.length > i; i++) {
            if (this.getInfoTopics[i].id.$oid === checkId) {
              var topicName = this.getInfoTopics[i].topic;
              this.setTopicId = this.getInfoTopics[i].id.$oid;
              var topicId = this.getInfoTopics[i].id.$oid;
            }
          }
          this.infoTopicsName = topicName;
          this.infoTopicsId = topicId;
          this.spinner = false;
          this.tableData[index].read = 'Y';
        },
       error: (error:HttpErrorResponse) => {
          this.spinner = false;
          console.log(error);
        }
      });
    }

    if (this.showData === 'text') {
      this.getTableIndex = index;
      this.infoDetails = this.textTableData[index];
      if (
        this.infoDetails.language === 'en' ||
        this.infoDetails.language === 'en-US'
      ) {
        this.infoDetailsLanguage = 'English';
      }
      if (this.infoDetails.language === 'hi') {
        this.infoDetailsLanguage = 'Hindi';
      }
      if (this.infoDetails.language === 'es') {
        this.infoDetailsLanguage = 'Spanish';
      }
      if (this.infoDetails.language === 'kn') {
        this.infoDetailsLanguage = 'Kannada';
      }
      const checkId = this.textTableData[index].topic.toString();
      this.textService.getTextInfo().subscribe({
        next: (res:any) => {
          const data: any = res;
          this.getInfoTopics = data.topics;
          this.storeId = this.textTableData[index]?.topic;
          for (let i = 0; this.getInfoTopics.length > i; i++) {
            if (this.getInfoTopics[i].id.$oid === checkId) {
              var topicName = this.getInfoTopics[i].topic;
              this.setTopicId = this.getInfoTopics[i].id.$oid;
              var topicId = this.getInfoTopics[i].id.$oid;
            }
          }
          this.infoTopicsName = topicName;
          this.infoTopicsId = topicId;
          this.spinner = false;
          this.textTableData[index].read = 'Y';
        },
       error: (error:HttpErrorResponse) => {
          console.log(error);
        }
      });
    }
  }

  getIndex(index: number) {
    this.getRecordIndex = index;
  }

  deleteSelectRecord(index: number) {
    this.bodySpinner = true;
      this.storeId = this.textTableData[index]['id'];
       
      this.textService.deleteTextTable(this.storeId).subscribe({
       next: (res:any) => {
          this.textTableData.splice(index, 1);
          this.records1.total_records = this.records1.total_records - 1;
          this.notifier.notify('default', 'Deleted Successfully.');
          this.bodySpinner = false;
        },
       error:(error:HttpErrorResponse) => {
          this.bodySpinner = false;
          console.log(error);
        }
    });
    
     
  }
 

 
  async makePDF() {
    this.downloadBtnSpinner = true;
    this.displaySentiment = true;
    let doc = new jsPDF();
    doc.setFontSize(22);
    doc.setTextColor(25, 118, 210);
    doc.text('Recorded Call Analysis Report', 105, 10, { align: 'center' });
    if (
      this.transcribedLgVariable !== 'Hindi' &&
      this.transcribedLgVariable !== 'Tamil' &&
      this.transcribedLgVariable !== 'Kannada' &&
      this.transcribedLgVariable !== 'Telugu'
    ) {
      autoTable(doc, {
        html: '#report-top-details',
        theme: 'grid',
        includeHiddenHtml: true,
        margin: { top: 20 },
        columnStyles: {
          0: { textColor: [0, 0, 0] },
          2: { textColor: [0, 0, 0] },
        },
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      await html2canvas(document.getElementById('sentimentCard3')!, {
        allowTaint: true,
        useCORS: true,
        imageTimeout: 1000,
        scale: 2,
        onclone: (cloneDoc) => {
          cloneDoc.getElementById('sentimentCard3')!.style.display = 'block';
        },
      }).then((canvas) => {
        var imgData = canvas.toDataURL('image/png');
        doc.addImage(imgData, 'PNG', 40, 52, 130, 50);
      });

      autoTable(doc, {
        html: '#transcriptReport',
        theme: 'grid',
        includeHiddenHtml: true,
        startY: 110,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      autoTable(doc, {
        html: '#question-answer-report',
        theme: 'grid',
        pageBreak: 'avoid',
        includeHiddenHtml: true,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      autoTable(doc, {
        columns: [{ header: 'Keyword/Phrases' }],
        html: '#keyword-phrases-table-report',
        theme: 'grid',
        includeHiddenHtml: true,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      autoTable(doc, {
        columns: [{ header: 'Most Used Words' }],
        html: '#most-used-words-table-report',
        theme: 'grid',
        includeHiddenHtml: true,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });
      doc.save(this.downloadReportName + '' + '.pdf');
      this.downloadBtnSpinner = false;
      this.spinner = false;
      this.getDownloadIndex = -1;
    } else {
      if (this.transcribedLgVariable === 'Hindi') {
        this.fontLanguage = hindiText;
        this.ttfName = 'NotoSansDevanagari-VariableFont_wdth,wght-normal.ttf';
        this.fontName = 'NotoSansDevanagari-VariableFont_wdth,wght';
        this.fontStyle = 'normal';
      }
      if (this.transcribedLgVariable === 'Tamil') {
        this.fontLanguage = tamilText;
        this.ttfName = 'New_Kannan_Text-normal.ttf';
        this.fontName = 'New_Kannan_Text';
        this.fontStyle = 'normal';
      }
      if (this.transcribedLgVariable === 'Kannada') {
        this.fontLanguage = kannadaText;
        this.ttfName = 'BalooTamma2-Regular-normal.ttf';
        this.fontName = 'BalooTamma2-Regular';
        this.fontStyle = 'normal';
      }
      if (this.transcribedLgVariable === 'Telugu') {
        this.fontLanguage = teluguText;
        this.ttfName = 'HindGuntur-Regular-normal.ttf';
        this.fontName = 'HindGuntur-Regular';
        this.fontStyle = 'normal';
      }
      doc.addFileToVFS(this.ttfName, this.fontLanguage);
      doc.addFont(this.ttfName, this.fontName, this.fontStyle);
      doc.setFont(this.fontName);
      autoTable(doc, {
        styles: {
          font: this.fontName,
          fontStyle: this.fontStyle,
        },
        html: '#report-top-details',
        theme: 'grid',
        includeHiddenHtml: true,
        margin: { top: 20 },
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      await html2canvas(document.getElementById('sentimentCard3')!, {
        allowTaint: true,
        useCORS: true,
        imageTimeout: 1000,
        scale: 2,
        onclone: (cloneDoc:any) => {
          cloneDoc.getElementById('sentimentCard3')!.style.display = 'block';
        },
      }).then((canvas:any) => {
        var imgData = canvas.toDataURL('image/png');
        doc.addImage(imgData, 'PNG', 40, 52, 130, 50);
      });

      autoTable(doc, {
        styles: {
          font: this.fontName,
          fontStyle: this.fontStyle,
        },
        html: '#transcriptReport',
        theme: 'grid',
        includeHiddenHtml: true,
        startY: 110,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      autoTable(doc, {
        styles: {
          font: this.fontName,
          fontStyle: this.fontStyle,
        },
        html: '#question-answer-report',
        theme: 'grid',
        pageBreak: 'avoid',
        includeHiddenHtml: true,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      autoTable(doc, {
        styles: {
          font: this.fontName,
          fontStyle: this.fontStyle,
        },
        columns: [{ header: 'Keyword/Phrases' }],
        html: '#keyword-phrases-table-report',
        theme: 'grid',
        includeHiddenHtml: true,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      autoTable(doc, {
        styles: {
          font: this.fontName,
          fontStyle: this.fontStyle,
        },
        columns: [{ header: 'Most Used Words' }],
        html: '#most-used-words-table-report',
        theme: 'grid',
        includeHiddenHtml: true,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });
      doc.save(this.downloadReportName + '' + '.pdf');
      this.downloadBtnSpinner = false;
      this.spinner = false;
      this.getDownloadIndex = -1;
    }
  }

  clearModalData() {
    setTimeout(() => {
      this.metricsMatches = [];
      this.QAMetricsData = [];
    }, 400);
    this.showManualInput = false;
  }

  showManualField(index: any) {
    this.showManualInput = true;
    this.getMetricsIndex = index;
    this.metricsMScore =
      this.QAMetricsData.qa_metrics?.metrics_matches?.[
        this.getMetricsIndex
      ].manual_score;
    this.metricsMComments =
      this.QAMetricsData.qa_metrics?.metrics_matches?.[
        this.getMetricsIndex
      ].manual_comments;
  }

  clearSentimentData() {
    setTimeout(() => {
      this.sentimentGraphData = [];
      this.lineChartData.datasets[0].data = [];
      this.sentimentData = [];
      this.sentimentPostiveWords = [];
      this.sentimentNeutralWords = [];
      this.sentimentNegativeWords = [];
      this.customerPostiveWords = [];
      this.customerNeutralWords = [];
      this.customerNegativeWords = [];
      this.agentPostiveWords = [];
      this.agentNeutralWords = [];
      this.agentNegativeWords = [];
      this.lineChartData.labels = [];
      this.showsentiment = '';
      this.showSentimentWords = '';
    }, 400);
  }

  searchTableData(value: string) {
    if (this.showData === 'pdf') {
      this.getInputSearchValue = value;
      this.textPayload = {
        pageno: 1,
        limit: this.limit,
        sort: [{ property: 'created_date', dir: 'DESC' }],
        search: this.getInputSearchValue ? this.getInputSearchValue : '',
        meet_user: 'N',
      };
      this.pageChanged(1);
    }

    if (this.showData === 'text') {
      this.getInputSearchValue = value;
      this.textPayload = {
        pageno: 1,
        limit: this.limit,
        sort: [{ property: 'created_date', dir: 'DESC' }],
        search: this.getInputSearchValue ? this.getInputSearchValue : '',
        meet_user: 'N',
      };
      this.pageChanged(1);
    }
  }

  hideMinimizedModal(value: string) {
    if (value === 'Transcript') {
      this.transcriptMinimizedBoolean = false;
      this.transcriptMinimizedHeader = '';
    }
  }

  showMinimizedModal(value: string) {
    if (value === 'Transcript') {
      this.transcriptMinimizedBoolean = true;
      this.transcriptMinimizedHeader = value;
    }
  }

  modalFullScreen(value: string) {
    if (value === 'max') {
      this.modalScreenSize = 'modal-fullscreen';
    }
    if (value === 'min') {
      this.modalScreenSize = '';
    }
  }

  deleteEmailTableData() {
    // this.emailService.deleteEmailData()
  }

  getTranslateDataFun_1(index: number) {
    this.spinner = true;
    if (this.showData === 'pdf') {
      this.storeId = this.tableData[index]?.file_id.$oid;
      this.displayName = this.tableData[index]?.display_file_name;
      this.pdfService.getTranscriptionOriginalText(this.storeId).subscribe({
        next: (response:any) => {
          this.translateResponseData_originalTemp = response;
          this.getTranslateLanguage =
            this.translateResponseData_originalTemp?.language.slice(0, 2);
          for (let i = 0; this.tranlateLanguages.length > i; i++) {
            if (this.tranlateLanguages[i].value === this.getTranslateLanguage) {
              this.selectedTranslate_1 = this.tranlateLanguages[i].lang;
              this.fromLanguage = this.tranlateLanguages[i].value;
            }
          }
          if (this.getTranslateLanguage === 'en') {
            this.translateResponseData_original =
              this.translateResponseData_originalTemp?.rawText.split(/[.?]/);
            this.selectedTranslate = this.tranlateLanguages[1].lang;
            this.fromLanguage = this.tranlateLanguages[0].value;
            this.toLanguage = this.tranlateLanguages[1].value;
            this.translateTextData(this.tranlateLanguages[1].value);
          } else {
            this.translateResponseData_original =
              this.translateResponseData_originalTemp?.spanish_raw_text.split(
                /[.?]/
              );
            this.selectedTranslate = this.tranlateLanguages[0].lang;
            this.toLanguage = this.tranlateLanguages[0].value;
            for (let i = 0; this.tranlateLanguages.length > i; i++) {
              if (
                this.tranlateLanguages[i].value === this.getTranslateLanguage
              ) {
                this.fromLanguage = this.tranlateLanguages[i].value;
              }
            }
            this.translateTextData(this.tranlateLanguages[0].value);
          }
          this.spinner = false;
        },
        error: (error:HttpErrorResponse) => {
          this.spinner = false;
          console.log('translate api error', error.error['message']);
        },
      });
    }
    if (this.showData === 'text') {
      this.storeId = this.textTableData[index]?.file_id.$oid;
      this.displayName = this.textTableData[index]?.display_file_name;
      this.textService.getTranscriptionOriginalText(this.storeId).subscribe({
        next: (response:any) => {
          this.translateResponseData_originalTemp = response;
          this.getTranslateLanguage =
            this.translateResponseData_originalTemp?.language.slice(0, 2);
          for (let i = 0; this.tranlateLanguages.length > i; i++) {
            if (this.tranlateLanguages[i].value === this.getTranslateLanguage) {
              this.selectedTranslate_1 = this.tranlateLanguages[i].lang;
            }
          }
          if (this.getTranslateLanguage === 'en') {
            this.translateResponseData_original =
              this.translateResponseData_originalTemp?.rawText.split(/[.?]/);
            this.selectedTranslate = this.tranlateLanguages[1].lang;
            this.fromLanguage = this.tranlateLanguages[0].value;
            this.toLanguage = this.tranlateLanguages[1].value;
            this.translateTextData(this.tranlateLanguages[1].value);
          } else {
            this.translateResponseData_original =
              this.translateResponseData_originalTemp?.spanish_raw_text.split(
                /[.?]/
              );
            this.selectedTranslate = this.tranlateLanguages[0].lang;
            this.toLanguage = this.tranlateLanguages[0].value;
            for (let i = 0; this.tranlateLanguages.length > i; i++) {
              if (
                this.tranlateLanguages[i].value === this.getTranslateLanguage
              ) {
                this.fromLanguage = this.tranlateLanguages[i].value;
              }
            }
            this.translateTextData(this.tranlateLanguages[0].value);
          }
          this.spinner = false;
        },
        error: (error:HttpErrorResponse) => {
          this.spinner = false;
          console.log('translate api error', error.error['message']);
        },
      });
    }
  }

  translateTextData(formValue: any) {
    if (this.getTranslateLanguage === 'en' && !this.translateResponseDataTemp) {
      this.spinner = true;
    } else {
      this.translateSpinner = true;
    }
    if (formValue === 'en') {
      this.fromLanguage = 'es';
    } else {
      this.fromLanguage = 'en';
    }
    this.toLanguage = formValue;
    const payload = {
      fromlanguage: this.fromLanguage,
      tolanguage: this.toLanguage,
      type: 0,
      text: this.translateResponseData_originalTemp?.rawText,
      fileid: this.storeId,
    };
    if (this.showData === 'pdf') {
      this.pdfService.getTranslatedLanguageData(payload).subscribe({
        next: (response:any) => {
          this.translateResponseDataTemp = response;
          this.translateResponseData =
            this.translateResponseDataTemp.result.split(/[.?]/);
          this.translateSpinner = false;
          this.spinner = false;
        },
        error: (error:HttpErrorResponse) => {
          console.log('translate api error', error.error['message']);
          this.translateSpinner = false;
          this.spinner = false;
        },
      });
    }
    if (this.showData === 'text') {
      this.textService.getTranslatedLanguageData(payload).subscribe({
        next: (response:any) => {
          this.translateResponseDataTemp = response;
          this.translateResponseData =
            this.translateResponseDataTemp.result.split(/[.?]/);
          this.translateSpinner = false;
          this.spinner = false;
        },
        error: (error:HttpErrorResponse) => {
          console.log('translate api error', error.error['message']);
          this.translateSpinner = false;
          this.spinner = false;
        },
      });
    }
  }

  clearTranslateModalData() {
    setTimeout(() => {
      this.translateResponseData_originalTemp = [];
      this.translateResponseData_original = [];
      this.translateResponseData = [];
      this.translateResponseDataTemp = [];
      this.fromLanguage = '';
      this.toLanguage = '';
      this.storeId = '';
      this.selectedTranslate = '';
      this.selectedTranslate_1 = '';
    }, 400);
  }

  globalSearchHighlighterFun() {
    setTimeout(() => {
      if (this.tableSearch || this.searchText2) {
        this.searchText = this.tableSearch;
        if (this.showData === 'emailTable') {
          this.searchText = this.searchText2;
        }
      } else {
        this.searchText = '';
      }
    }, 200);
  }

   newLine(data:any){
    return  data.replaceAll(/\n/g, '<br />');
  }

  showQADetails(result: any,index:number) {
    const qaData: any[] = result?.question_answer || [];
   
    this.QA_Pairs = result?.question_answer[0]['qa_pairs'];
    
  }

}
